class ArticleCtaBar extends HTMLElement {
  #bar = null;
  #wrap = null;
  #dismissed = false;
  #onScroll = null;
  #resizeObserver = null;
  #offsetPx = null;

  connectedCallback() {
    this.#bar = this.querySelector('.article-cta-bar');
    if (!this.#bar) return;

    this.#wrap = this.#bar.querySelector('.article-cta-bar__wrap');
    document.body.appendChild(this.#bar);

    const dismissButton = this.#bar.querySelector('[data-cta-dismiss]');
    dismissButton?.addEventListener('click', () => this.#dismiss());

    this.#onScroll = () => this.#handleScroll();
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#resizeObserver = new ResizeObserver(() => this.#syncOffset());
    this.#resizeObserver.observe(this.#wrap ?? this.#bar);
    this.#handleScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
    this.#resizeObserver?.disconnect();
    this.#clearOffset();
    this.#bar?.remove();
  }

  #dismiss() {
    this.#dismissed = true;
    this.#bar?.classList.remove('article-cta-bar--visible');
    this.#bar?.classList.add('article-cta-bar--hidden');
    this.#syncOffset();
  }

  #handleScroll() {
    if (this.#dismissed || !this.#bar) return;

    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const viewportHeight = window.innerHeight;
    const showThreshold = viewportHeight * 0.45;
    const footer = document.getElementById('tt-footer');

    let hideForFooter = false;

    if (footer) {
      const footerTop = footer.getBoundingClientRect().top;
      hideForFooter = footerTop < viewportHeight - 80;
    }

    const distanceFromBottom =
      document.documentElement.scrollHeight - scroll - viewportHeight;
    hideForFooter = hideForFooter || distanceFromBottom < 150;

    const shouldShow = scroll >= showThreshold && !hideForFooter;

    if (shouldShow) {
      this.#bar.classList.add('article-cta-bar--visible');
      this.#bar.classList.remove('article-cta-bar--hidden');
      this.#syncOffset();
      return;
    }

    this.#bar.classList.remove('article-cta-bar--visible');

    if (scroll >= showThreshold) {
      this.#bar.classList.add('article-cta-bar--hidden');
    }
    this.#syncOffset();
  }

  #syncOffset() {
    const visible = Boolean(this.#bar?.classList.contains('article-cta-bar--visible'));
    const source = this.#wrap ?? this.#bar;
    const height = visible && source ? Math.round(source.getBoundingClientRect().height) : 0;

    if (height === this.#offsetPx) {
      document.body.classList.toggle('has-article-cta-bar', visible);
      return;
    }

    this.#offsetPx = height;
    document.documentElement.style.setProperty('--article-cta-offset', `${height}px`);
    document.body.classList.toggle('has-article-cta-bar', visible);

    const chip = document.querySelector('.article-nav-chip');
    if (chip) {
      chip.style.transform = height
        ? `translate3d(0, ${-height}px, 0)`
        : 'translate3d(0, 0, 0)';
    }
  }

  #clearOffset() {
    this.#offsetPx = null;
    document.documentElement.style.removeProperty('--article-cta-offset');
    document.body.classList.remove('has-article-cta-bar');
    const chip = document.querySelector('.article-nav-chip');
    chip?.style.removeProperty('transform');
  }
}

customElements.define('article-cta-bar', ArticleCtaBar);
